import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-P6TT',
        },
    },
    host: 'fr.zalando-lounge.be',
});
